import { Edit, RefreshButton, SaveButton, useForm } from '@refinedev/antd';

import ProtectedDeleteButton from '@/components/protected/ProtectedDeleteButton';
import { ShippingLabel } from '@/model/Logistic/ShippingLabel/ShippingLabel';

import ShippingLabelForm from './ShippingLabelsForm/ShippingLabelForm';

const ShippingLabelEdit = () => {
  const { formProps, saveButtonProps, query } = useForm<ShippingLabel>({
    successNotification: {
      message: 'Etiqueta de envío actualizada correctamente',
      type: 'success',
    },
  });

  return (
    <Edit
      isLoading={query?.isLoading || query?.isFetching}
      footerButtons={({ deleteButtonProps }) => (
        <>
          <ProtectedDeleteButton {...deleteButtonProps} />
          <SaveButton {...saveButtonProps} />
        </>
      )}
      headerButtons={({ refreshButtonProps }) => <RefreshButton {...refreshButtonProps} />}>
      {query?.data && <ShippingLabelForm formProps={formProps} edit />}
    </Edit>
  );
};

export default ShippingLabelEdit;
